export default [
  {
    path: '/mng/account/profile',
    name: 'profile',
    component: () => import('@/pages/mng/account_info/App.vue'),
    meta: {
      title: '个人资料',
    },
  },
];
